import { render, staticRenderFns } from "./a-input.vue?vue&type=template&id=5957af60&scoped=true"
import script from "./a-input.vue?vue&type=script&lang=js"
export * from "./a-input.vue?vue&type=script&lang=js"
import style0 from "./a-input.vue?vue&type=style&index=0&id=5957af60&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5957af60",
  null
  
)

export default component.exports